var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVendorLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 9.15591V12.9104C2.5 15.2702 2.5 16.4502 3.23223 17.1833C3.96447 17.9165 5.14297 17.9165 7.5 17.9165H12.5C14.857 17.9165 16.0355 17.9165 16.7677 17.1833C17.5 16.4502 17.5 15.2702 17.5 12.9104V9.15591",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 14.1473C11.9299 14.6533 11.0223 14.9807 9.99998 14.9807C8.97764 14.9807 8.07008 14.6533 7.5 14.1473",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8298 2.08578L5.12494 2.11002C3.67646 2.0354 3.30508 3.15216 3.30508 3.69807C3.30508 4.18632 3.2422 4.89812 2.35445 6.23592C1.46669 7.57372 1.5334 7.97113 2.034 8.89725C2.44948 9.66592 3.50625 9.96617 4.05726 10.0167C5.80744 10.0565 6.65895 8.54308 6.65895 7.47936C7.52717 10.1521 9.99639 10.1521 11.0966 9.84642C12.1989 9.54025 13.1431 8.44425 13.366 7.47936C13.4959 8.6785 13.8902 9.37817 15.0553 9.859C16.2621 10.357 17.3 9.59583 17.8207 9.10783C18.3415 8.61992 18.6756 7.53667 17.7474 6.34608C17.1072 5.52501 16.8404 4.7515 16.7528 3.94981C16.702 3.48528 16.6574 2.98613 16.3311 2.66849C15.8541 2.20429 15.1697 2.06344 14.8298 2.08578Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendorLight);
export default __webpack_public_path__ + "static/media/vendor_light.23901ce3eac44c187f3159cef2db2d77.svg";
export { ForwardRef as ReactComponent };